export default __webpack_public_path__ + "static/media/img-0024.0490d392.png";